// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VWyb","col":"styles_col__18Eyu"};